import { Component, inject } from '@angular/core';
import {
	SCHEDULE_DETAIL_KIND,
	ScheduleDetailFacade,
	type ScheduleDetailKind,
} from 'src/app/facades/schedule-detail.facade';

@Component({
	standalone: false,
	selector: 'app-yas',
	templateUrl: './yas.component.html',
	styleUrls: ['./yas.component.scss'],
	providers: [{ provide: SCHEDULE_DETAIL_KIND, useValue: 'yas' satisfies ScheduleDetailKind }, ScheduleDetailFacade],
})
export class YASComponent {
	protected readonly facade = inject(ScheduleDetailFacade);

	constructor() {
		this.facade.start();
	}
}
